import { ActionReducerMap } from '@ngrx/store';
import { navigationReducer } from '../layout/navigation/state/navigation.reducer';
import { IPolCoreState } from '../models/state.model';
import { providerStateReducer, userStateReducer } from './core.reducers';

export const coreReducers: ActionReducerMap<IPolCoreState> = {
  userState: userStateReducer,
  navigationState: navigationReducer,
  providerState: providerStateReducer,
};
